var Datepicker = (function() {
	var __private = {
		set: function(obj) {
			this.container = obj.container;
			this.hiddenInput = obj.hiddenInput;
			this.tableClass = "table-datapicker";
			this.tdMonthId  = "datepickerMonths";
			this.tdYearId   = "datepickerYears";
			this.disabled   = "disabled";
			this.check      = "check";
			this.yearLimit = 5;
		},

		createTable: function(ID, inpName) {
			var table = document.createElement("table");

			var yy = [];
			var start = this.yearLimit * -1;
			var end = this.yearLimit;
			for(var y = start; y <= end; y++) {
				yy.push(this.config.y() + y);
			}
			
			this.date = {
				dd: this.config.d,
				mm: "",
				yy: "",
				s: this.config.separator
			}

			table.classList.add(this.tableClass);
			table.innerHTML = `
				<thead>
					<tr>
						<th class="text-left"><span class="btn prevY"></span></th>
						<th><div id=${this.tdYearId} class=${this.tableClass}__years></div></th>
						<th class="text-right"><span class="btn nextY"></span></th>
					</tr>
				</thead>
				<tbody id=${this.tdMonthId}></tbody>`;

			this.container.appendChild(table);
			this.addYear(this.config.y());
			this.addMonths(this.config.m);

			this.container.addEventListener("click", function(event) {
				event = event || window.event;
				
				var el = event.target;

				if(el.classList.contains("prevY")) __private.prev(el, yy);
				if(el.classList.contains("nextY")) __private.next(el, yy);
				if(el.classList.contains(__private.tableClass + "__year")) __private.getDate(el, "yy");
				if(el.classList.contains(__private.tableClass + "__month")) __private.getDate(el, "mm");

				if(__private.date.mm !== "" && __private.date.yy !== "") {
					let value = __private.date.yy + __private.date.s + __private.date.mm + __private.date.s + __private.date.dd;
					__private.hiddenInput.value = value;
					console.info("Dealer License Expiration Date: " + value);
				}
			});
		},

		addYear: function(year) {
			let span = document.createElement("span");
			span.classList.add(this.tableClass + "__year");
			span.classList.add("btn");

			span.innerText = year;
			span.dataset.value = year;
			span.dataset.index = this.yearLimit;

			document.getElementById(this.tdYearId).appendChild(span);
		},

		addMonths: function(monaths) {
			let tdInLine = 3;
			let className = this.tableClass + "__month";

			for(let i = 1; i <= 12; i += tdInLine) {
				let key1 = keys(i);
				let key2 = keys(i + 1);
				let key3 = keys(i + 2);

				let tr = document.createElement("tr");
				tr.innerHTML = `
					<td><span class="btn ${className}" data-value=${key1}>${monaths[key1]}</span></td>
					<td><span class="btn ${className}" data-value=${key2}>${monaths[key2]}</span></td>
					<td><span class="btn ${className}" data-value=${key3}>${monaths[key3]}</span></td>
				`;

				document.getElementById(this.tdMonthId).appendChild(tr);
			}

			function keys(i) {
				if(i < 10) return "0" + i;
				else return i;
			}
		},

		prev: function(el, arr) {
			let span = document.getElementById(this.tdYearId).children[0];
			let index = span.dataset.index;
			span.classList.remove(this.check);

			if(index > 0) {
				span.innerText = arr[index - 1];
				span.dataset.value = arr[index - 1];
				span.dataset.index = index - 1;

				if( this.container.getElementsByClassName("nextY")[0].classList.contains(this.disabled) ) 
					this.container.getElementsByClassName("nextY")[0].classList.remove(this.disabled);

				if(index == 1) el.classList.add(this.disabled);
			} 
		},

		next: function(el, arr) {
			let span = document.getElementById(this.tdYearId).children[0];
			let index = span.dataset.index;
			span.classList.remove(this.check);

			if( index < (arr.length - 1) && index >= 0) {
				span.innerText = arr[+index + 1];
				span.dataset.value = arr[+index + 1];
				span.dataset.index = +index + 1;
				
				if(this.container.getElementsByClassName("prevY")[0].classList.contains(this.disabled)) 
					this.container.getElementsByClassName("prevY")[0].classList.remove(this.disabled);

				if(index == (arr.length - 2)) el.classList.add(this.disabled);
			}
		},

		getDate: function(el, param) {
			let val = el.dataset.value;

			var parent = parentEl(el);
			var spans;
			if(param === "mm") spans = parent.getElementsByClassName(this.tableClass + "__month");
			else spans = parent.getElementsByClassName(this.tableClass + "__year");
			function parentEl(elem) {
				if(elem.parentElement.tagName === "TBODY" || elem.parentElement.tagName === "THEAD") return elem.parentElement;
				else return parentEl(elem.parentElement);
			};

			for(let i = 0; i < spans.length; i++) {
				spans[i].classList.remove(this.check);
			}
			el.classList.add(this.check);

			this.date[param] = val;
		},

		config: {
			d: "01",
			m: {
				"01": "January",
				"02": "February",
				"03": "March",
				"04": "April",
				"05": "May",
				"06": "June",
				"07": "July",
				"08": "August",
				"09": "September",
				"10": "October",
				"11": "November",
				"12": "December",
			},
			y: function() {
				return new Date().getFullYear();
			},

			separator: "-"
		}
	};

	return {
		init: function(obj) {
			__private.set(obj);
			__private.createTable();
		}
	};
})();

(function() {
	document.addEventListener("DOMContentLoaded", function() {

		// create calendar
		var hidden = document.getElementById("dealerLicenseExpiration");
		var containerForColendar = document.getElementById("calendar");
		var showButton = document.getElementById("showCalendar");

		if(containerForColendar && hidden) {
			Datepicker.init({
				container: containerForColendar,
				hiddenInput: hidden
			});

			// show calendat
			if(showButton) {
				showButton.addEventListener("click", function() {
					containerForColendar.classList.toggle("display_none");
				});
			}
		}

		
	});
})();